import { FC, ReactElement } from 'react'

import Breadcrumbs from '../components'
import { BreadcrumbProps } from '../components/breadcrumb'

import './index.css'

export type BlogBreadCrumbsProp = {
  path: string
  title: string
}

const BlogBreadCrumbs: FC<BlogBreadCrumbsProp> = ({ path, title }): ReactElement => {
  const breadcrumbs: BreadcrumbProps[] = []
  const className = {
    container: 'blog-breadcrumbs-container',
    each_breadcrumb: { link: 'blog-breadcrumbs-link', title: 'blog-breadcrumbs-title', last_title: 'blog-breadcrumbs-last-title' },
  }

  const handlePrePath = () => {
    breadcrumbs.push({ title: 'Home', path: '/' })
    breadcrumbs.push({ title: 'Blogs', path: '/blogs' })
    breadcrumbs.push({ title: title, path: path || window.location.pathname })

    return <Breadcrumbs breadcrumbs={breadcrumbs} className={className} />
  }

  return handlePrePath()
}

export default BlogBreadCrumbs
